import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import 'school-space-client/styles/global.css';
import StylesProvider from 'school-space-client/styles';
import { DeviceProvider, ModalProvider } from 'school-space-client/components';
import NotificationProvider from 'shared/context/notification/NotificationProvider';

import App from './App';

import services from './services';
import './style.css';

services.start();

ReactDOM.render(
    <StylesProvider>
        <Router>
            <DeviceProvider>
                <ModalProvider>
                    <NotificationProvider>
                        <App />
                    </NotificationProvider>
                </ModalProvider>
            </DeviceProvider>
        </Router>
    </StylesProvider>,
    document.getElementById('root')
);
